import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import { INSTAGRAM_URL, INSTAGRAM_HANDLE } from "@/lib/contact";

const shots = [
  "https://images.unsplash.com/photo-1588350350703-fddbfc5cfaf6?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  "https://images.unsplash.com/photo-1641970963562-912cf0ace893?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  "https://images.unsplash.com/photo-1567418938902-aa650a3eb346?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  "https://images.pexels.com/photos/30891127/pexels-photo-30891127.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/35168511/pexels-photo-35168511.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1523308458373-c6f61ae1fd21?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
];

export default function InstagramGallery() {
  return (
    <section className="border-t border-line py-24 lg:py-32" data-testid="instagram-gallery">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-14">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-clay font-medium mb-5">Галерия</p>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink">Последвайте Айлян</h2>
          </div>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 self-start border border-line rounded-full px-6 py-3 text-sm text-ink hover:bg-ink hover:text-cream transition-colors duration-300"
            data-testid="instagram-follow"
          >
            <Instagram className="w-4 h-4" strokeWidth={1.5} /> {INSTAGRAM_HANDLE}
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
          {shots.map((src, i) => (
            <motion.a
              key={i}
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: (i % 6) * 0.06 }}
              className="group relative overflow-hidden rounded-lg aspect-square bg-sand"
              data-testid={`instagram-shot-${i}`}
            >
              <img src={src} alt="Цветя от Айлян" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <span className="absolute inset-0 bg-ink/0 group-hover:bg-ink/30 transition-colors duration-300 flex items-center justify-center">
                <Instagram className="w-6 h-6 text-cream opacity-0 group-hover:opacity-100 transition-opacity duration-300" strokeWidth={1.5} />
              </span>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
